module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/assessment_achievements/6_df360b44837685c335b6fb571d15b4a7.png";